var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{attrs:{"minimum-view":_vm.minimumView,"value":_vm.value,"full-month-name":true,"disabled-dates":_vm.disabledDates,"open-date":_vm.openDate,"format":_vm.format,"input-class":"form-control border border-dark","calendar-class":"bg-skyblue"},on:{"input":_vm.updateSelected}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b3c8310","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/common/Picker.vue
// module id = f4/N
// module chunks = 0